import { render } from "./identification.vue?vue&type=template&id=2674e4e2"
import script from "./identification.vue?vue&type=script&lang=ts"
export * from "./identification.vue?vue&type=script&lang=ts"
script.render = render

export default script